import { TextField } from '@packages/shared';
import type { FC, JSX } from 'react';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

export const AplusServiceCountTextField: FC<{
  count: number;
  maximum: number | null;
  onChange: (count: number) => void;
}> = ({ count, maximum, onChange }): JSX.Element => {
  const [value, setValue] = useState<number | ''>(count);
  // extract this into config if needed
  const min = 1;
  const max = maximum;

  // Why this effect?
  // Correct the input value if backend delivers a different one
  // https://stackoverflow.com/questions/59123359/react-input-field-not-re-rendering-refreshing
  useEffect(() => {
    setValue(count);
  }, [count]);

  const onChangeHandler = (newValue: number) => {
    // this happens when the number is deleted from the input field
    // prevent the user from typing invalid values
    let corrected = newValue;
    if (corrected < min) {
      corrected = min;
    }
    if (max && corrected > max) {
      corrected = max;
    }
    // set the value and trigger onchange (backend call)
    setValue(corrected);
    onChange(corrected);
  };

  return (
    <TextField
      data-testid="aplus-service-count"
      type="number"
      label={
        <FormattedMessage
          key="Aplus.serviceCount-text"
          id="Aplus.serviceCount"
          defaultMessage="Anzahl"
        />
      }
      value={value}
      onChange={(e) => onChangeHandler(parseInt(e.target.value, 10))}
      inputProps={{ min, max }}
    />
  );
};
